import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, getDocs, where, collection, query } from "firebase/firestore"
import { useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ApplicantTable from '../../../components/table/ApplicantTable'
import { AuthContext } from "../../../context/AuthContext";
import DataTableUserApplication from "../../../components/dataTable/DataTableUserApplication"

const Single = () => {

  const {contactId} = useParams()
 
  // const { currentUser } = useContext(AuthContext)


  const [ userData, setUserData ] = useState("")


  const getContact = async() => {

      const docRef = doc(db, "contact", contactId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setUserData(docSnap.data())
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{
    getContact()
  }, [])


  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 className='title'>Information</h2>
            <div className='item'>
            <img
                src = {userData.img ? userData.img : "../images/user.png"}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
            /> 
              

          
              <div className="details">
                  <h3 className='itemTitle'>{userData.name}</h3>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{userData.email}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone:</span>
                    <span className='itemValue'>{userData.telephone}</span>
                  </div>
                  
               
                </div>
               
                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Subject:</span>
                    <span className='itemValue'>{userData.subject}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Message:</span>
                    <span className='itemValue'>{userData.message}</span>
                  </div>
                               
                </div>
            </div>
          </div>
         
        </div>
        
      </div>
    </div>
  )
}

export default Single